import { DashboardLayoutCustomer } from "../../components/dashboard-layout-customer";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";

import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { useLocation, useNavigate } from "react-router-dom";

function SetTX() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [second, setSecond] = useState(0);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState(null);

    function formatDate(m) {
        const d = new Date(m);
        return d.getFullYear() + "/" + 
               ("0" + (d.getMonth() + 1)).slice(-2) + "/" + 
               ("0" + d.getDate()).slice(-2) + "  " + 
               ("0" + d.getHours()).slice(-2) + ":" + 
               ("0" + d.getMinutes()).slice(-2);
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const getBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = { "1": "CHẴN", "2": "LẺ", "3": "TÀI", "4": "XỈU" };
        return stateStr.split(" ").map(s => map[s] || s).join(", ");
    };

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/TX60s/list30bet?sanh=${SANH_ID}`).then((res) => {
            setList30(res.data.data);
        }).catch(() => setList30(null));

        axios.get(`${process.env.REACT_APP_API_URL}/tx60s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                setBet(res.data.data);
            }
        });
    };

    const fetchCurrentBets = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setCurrent(res.data.data);
        }).catch(() => setCurrent([]));
    };

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/tx60s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                setBet(res.data.data);
                setDulieunhap(new Date(res.data.data.createdAt));
            }
        }).catch(() => console.log("Chờ phiên mới..."));

        reloadHistorySilently();
        fetchCurrentBets(); 
    };

    useEffect(() => {
        setBet(null);
        setCurrent(null);
        fetchNewSessionAdmin();
    }, [SANH_ID]);

    useEffect(() => {
        if (!dulieunhap) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            const remaining = 60 - diffInSeconds; 

            if (remaining < 0) {
                setSecond(0);
                fetchNewSessionAdmin();
            } else {
                setSecond(remaining);
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    useEffect(() => {
        const pollInterval = setInterval(() => {
            fetchCurrentBets();
        }, 2000);
        return () => clearInterval(pollInterval);
    }, [SANH_ID]);

    function thongke(num) {
        if (current && current.length > 0) {
            let totalMoney = 0;
            current.forEach((item) => {
                const states = item.state.split(" ").map(Number);
                if (states.includes(num)) {
                    totalMoney += item.money / states.length;
                }
            });
            return Number(totalMoney).toLocaleString("vi-VN");
        }
        return 0;
    }

    const currentSessionData = list30?.find(item => item.id_bet === bet?.id_bet);
    const displayResult = currentSessionData?.result || bet?.result;

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayoutCustomer>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    <Container maxWidth={false}>
                        {/* CHỌN SẢNH */}
                        <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
                            {[1, 2, 3, 4, 5, 6].map((sanhId) => (
                                <Button
                                    key={sanhId}
                                    variant={SANH_ID === sanhId ? "contained" : "outlined"}
                                    color="primary"
                                    onClick={() => navigate(`?sanh=${sanhId}`)}
                                    sx={{ fontWeight: 'bold', minWidth: '100px' }}
                                >
                                    SẢNH {sanhId}
                                </Button>
                            ))}
                        </Box>

                        <div className="container_set" style={{ textAlign: 'center', fontSize: '22px', fontWeight: 'bold', marginBottom: '10px' }}>
                            SẢNH {SANH_ID} - THEO DÕI TX 60S
                        </div>

                        {/* PHIÊN VÀ ĐỒNG HỒ */}
                        <Paper sx={{ p: 2, textAlign: 'center', mb: 3, bgcolor: '#f8f9fa' }}>
                            {bet ? (
                                <Typography variant="h6">
                                    {t('session')} <b style={{ color: '#1976d2' }}>{bet.id_bet}</b>
                                </Typography>
                            ) : (
                                <Typography>{t('waiting')}</Typography>
                            )}
                            <Typography sx={{ color: "red", fontSize: '32px', fontWeight: 'bold' }}>
                                00 : {second < 10 ? "0" : ""}{second >= 0 ? second : 0}
                            </Typography>
                        </Paper>

                        {/* THỐNG KÊ TIỀN CƯỢC HIỆN TẠI */}
                        <Box sx={{ mb: 3, p: 2, bgcolor: '#fff', borderRadius: 2, boxShadow: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, textAlign: 'center' }}>TỔNG TIỀN CƯỢC PHIÊN HIỆN TẠI</Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-around', textAlign: 'center' }}>
                                <Box>
                                    <Typography variant="body2">CHẴN</Typography>
                                    <Typography sx={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(1)}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body2">LẺ</Typography>
                                    <Typography sx={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(2)}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body2">TÀI</Typography>
                                    <Typography sx={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(3)}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body2">XỈU</Typography>
                                    <Typography sx={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(4)}</Typography>
                                </Box>
                            </Box>
                        </Box>

                        {/* KẾT QUẢ HIỆN TẠI */}
                        <Box sx={{ mt: 3, p: 2, bgcolor: 'white', borderRadius: 1, boxShadow: 1, textAlign: 'center', mb: 3 }}>
                            <Typography variant="h6">
                                {t('result_recent')} (Kết quả dự kiến):{" "}
                                <span style={{ fontWeight: "900", color: "red", fontSize: '24px' }}>
                                    {displayResult && displayResult.trim() !== "" ? displayResult : "Đang chờ..."}
                                </span>
                            </Typography>
                        </Box>

                        {/* DANH SÁCH KHÁCH ĐANG CƯỢC */}
                        <Typography variant="h6" sx={{ mb: 1 }}>DANH SÁCH ĐANG CƯỢC</Typography>
                        <Paper elevation={2} sx={{ mb: 4 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#eceff1' }}>
                                        <TableCell style={{ fontWeight: 'bold' }}>ID User</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Tài Khoản</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Cửa Đặt</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Tiền Cược</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Thời Gian</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {current && current.length > 0 ? (
                                        current.map((item, idx) => (
                                            <TableRow key={idx} hover>
                                                <TableCell>{item?.user?.iduser}</TableCell>
                                                <TableCell>{item?.user?.username}</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: '#e53935' }}>{getBetLabel(item.state)}</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: '#2e7d32' }}>{Number(item.money).toLocaleString("vi-VN")}</TableCell>
                                                <TableCell>{formatDate(item.createdAt)}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 3, color: '#999' }}>{t('no_player')}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Paper>

                    </Container>
                </Box>
            </DashboardLayoutCustomer>
        </ThemeProvider>
    );
}

export default SetTX;